import React, { useState, useEffect } from "react";
import { Grid, Card, CardMedia, CardContent, Typography, Box, Chip, Button, Menu, MenuItem, IconButton, TextField, InputAdornment } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import AdminEventService from "../dashboard/Locality/Service/adminEventService";
import Header from "./Header";
import Footer from "./Footer";
import './styles/bootstrap.min.css';
import './styles/main.css';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import LocationOnIcon from '@material-ui/icons/LocationOn';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(4),
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
    },
    eventsContainer: {
        maxWidth: '1400px',
        margin: '0 auto',
        padding: theme.spacing(2),
    },
    pageTitle: {
        textAlign: 'center',
        marginBottom: theme.spacing(4),
        color: '#333',
        fontWeight: 'bold',
        fontSize: '2rem',
    },
    eventCard: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        borderRadius: '12px',
        overflow: 'hidden',
        backgroundColor: '#fff',
        transition: 'transform 0.3s, box-shadow 0.3s',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
        },
    },
    imageContainer: {
        position: 'relative',
        width: '100%',
        height: '280px',
        overflow: 'hidden',
    },
    cardMedia: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    dateBar: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        color: '#fff',
        padding: '10px 16px',
        fontSize: '0.9rem',
        fontWeight: '500',
    },
    cardContent: {
        flexGrow: 1,
        padding: theme.spacing(2.5),
        display: 'flex',
        flexDirection: 'column',
    },
    eventTitle: {
        fontWeight: 'bold',
        fontSize: '1.1rem',
        marginBottom: theme.spacing(1),
        color: '#333',
        lineHeight: 1.3,
        minHeight: '2.6em',
    },
    eventLocation: {
        color: '#666',
        fontSize: '0.875rem',
        marginBottom: theme.spacing(0.5),
        lineHeight: 1.4,
    },
    eventCategory: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    noEvents: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: '#999',
        fontSize: '1.1rem',
    },
    eventsCount: {
        textAlign: 'center',
        marginBottom: theme.spacing(3),
        color: '#666',
        fontSize: '1rem',
    },
    headerSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1.5),
        padding: theme.spacing(1.5, 0),
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    headerTitle: {
        fontSize: '1.25rem',
        fontWeight: 'bold',
        color: '#333',
        display: 'none', // Hide title as per image
    },
    headerSubtitle: {
        fontSize: '0.9rem',
        color: '#666',
        fontWeight: '400',
    },
    headerRight: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    filterSection: {
        display: 'flex',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(3),
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    filterButton: {
        borderRadius: '20px',
        padding: theme.spacing(0.75, 2),
        textTransform: 'none',
        border: '1px solid #ddd',
        color: 'rgb(112, 57, 177)',
        fontWeight: '500',
        '&:hover': {
            backgroundColor: '#fff5f7',
            borderColor: 'rgb(112, 57, 177)',
        },
    },
    activeFilter: {
        backgroundColor: 'rgb(112, 57, 177)',
        color: '#fff',
        borderColor: 'rgb(112, 57, 177)',
        '&:hover': {
            backgroundColor: '#ff5570',
        },
    },
    menuPaper: {
        marginTop: theme.spacing(1),
        minWidth: '200px',
    },
    searchField: {
        marginBottom: theme.spacing(2),
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
        },
    },
}));

function Events(props) {
    const classes = useStyles();
    const [events, setEvents] = useState([]);
    const [allEvents, setAllEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedVenue, setSelectedVenue] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [categoryMenuAnchor, setCategoryMenuAnchor] = useState(null);
    const [cityMenuAnchor, setCityMenuAnchor] = useState(null);
    const [venueMenuAnchor, setVenueMenuAnchor] = useState(null);

    useEffect(() => {
        getEvents();
    }, []);

    useEffect(() => {
        applyFiltersAndSort();
    }, [selectedCategory, selectedCity, selectedVenue, searchQuery, allEvents]);

    const getEvents = () => {
        setLoading(true);
        AdminEventService.getAllAdminEvent()
            .then((res) => {
                // Filter only active events
                const activeEvents = (res || []).filter(event => event.status === 'active');
                setAllEvents(activeEvents);
                setEvents(activeEvents);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setEvents([]);
                setAllEvents([]);
                setLoading(false);
            });
    };

    const applyFiltersAndSort = () => {
        let filtered = [...allEvents];

        // Helper function to get city name from event
        const getCityName = (event) => {
            if (typeof event.cityId === 'object' && event.cityId?.city) {
                return event.cityId.city;
            }
            return event.city || '';
        };

        // Helper function to get category name from event
        const getCategoryName = (event) => {
            if (typeof event.categoryId === 'object' && event.categoryId?.category) {
                return event.categoryId.category;
            }
            return event.category || '';
        };

        // Apply search filter
        if (searchQuery) {
            filtered = filtered.filter(event => {
                const cityName = getCityName(event);
                const categoryName = getCategoryName(event);
                return (
                    event.eventName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    event.venue?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    cityName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    categoryName?.toLowerCase().includes(searchQuery.toLowerCase())
                );
            });
        }

        // Apply category filter
        if (selectedCategory) {
            filtered = filtered.filter(event => {
                const categoryName = getCategoryName(event);
                return categoryName?.toLowerCase() === selectedCategory.toLowerCase();
            });
        }

        // Apply city filter
        if (selectedCity) {
            filtered = filtered.filter(event => {
                const cityName = getCityName(event);
                return cityName?.toLowerCase() === selectedCity.toLowerCase();
            });
        }

        // Apply venue filter (Browse By Venues)
        if (selectedVenue) {
            filtered = filtered.filter(event => 
                event.venue?.toLowerCase() === selectedVenue.toLowerCase()
            );
        }

        setEvents(filtered);
    };

    const getUniqueCategories = () => {
        const categories = allEvents
            .map(event => {
                if (typeof event.categoryId === 'object' && event.categoryId?.category) {
                    return event.categoryId.category;
                }
                return event.category || '';
            })
            .filter(cat => cat && cat.trim() !== '')
            .filter((value, index, self) => self.indexOf(value) === index);
        return categories.sort();
    };

    const getUniqueCities = () => {
        const cities = allEvents
            .map(event => {
                if (typeof event.cityId === 'object' && event.cityId?.city) {
                    return event.cityId.city;
                }
                return event.city || '';
            })
            .filter(city => city && city.trim() !== '')
            .filter((value, index, self) => self.indexOf(value) === index);
        return cities.sort();
    };

    const getUniqueVenues = () => {
        const venues = allEvents
            .map(event => event.venue)
            .filter(venue => venue && venue.trim() !== '')
            .filter((value, index, self) => self.indexOf(value) === index);
        return venues.sort();
    };

    const handleCategoryFilter = (category) => {
        setSelectedCategory(category === selectedCategory ? '' : category);
        setCategoryMenuAnchor(null);
    };

    const handleCityFilter = (city) => {
        setSelectedCity(city === selectedCity ? '' : city);
        setCityMenuAnchor(null);
    };

    const handleVenueFilter = (venue) => {
        setSelectedVenue(venue === selectedVenue ? '' : venue);
        setVenueMenuAnchor(null);
    };

    const clearFilters = () => {
        setSelectedCategory('');
        setSelectedCity('');
        setSelectedVenue('');
        setSearchQuery('');
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { weekday: 'short', day: 'numeric', month: 'short' };
        return date.toLocaleDateString('en-US', options);
    };

    const formatDateForBar = (fromDate, toDate) => {
        if (!fromDate) return '';
        const from = new Date(fromDate);
        const fromFormatted = from.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short' });
        
        if (toDate && fromDate !== toDate) {
            const to = new Date(toDate);
            const toFormatted = to.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short' });
            return `${fromFormatted} to ${toFormatted}`;
        }
        return fromFormatted;
    };

    const formatTime = (timeString) => {
        if (!timeString) return '';
        if (timeString.includes(':')) {
            const timeParts = timeString.split(':');
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1] || '00';
            
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            if (hours === 0) {
                hours = 12;
            }
            
            return `${hours}:${minutes} ${ampm}`;
        }
        return timeString;
    };

    const getEventType = (eventName) => {
        // Simple categorization based on event name keywords
        const name = eventName.toLowerCase();
        if (name.includes('comedy') || name.includes('standup')) return 'Stand up Comedy';
        if (name.includes('improv')) return 'Improv Comedy';
        if (name.includes('circus')) return 'Circus';
        if (name.includes('concert') || name.includes('jamming') || name.includes('music')) return 'Concerts';
        if (name.includes('workshop')) return 'Workshop';
        if (name.includes('exhibition') || name.includes('exhibition')) return 'Exhibition';
        return 'Event';
    };

    const handleCardClick = (event) => {
        props.history.push(`/event/${event._id}`);
    };

    const uniqueCategories = getUniqueCategories();
    const uniqueCities = getUniqueCities();
    const uniqueVenues = getUniqueVenues();
    const hasActiveFilters = selectedCategory || selectedCity || selectedVenue || searchQuery;

    return (
        <>
            <Header history={props.history} />
            <Box className={classes.container}>
                <div className={classes.eventsContainer}>
                    {/* Header Section */}
                    <div className={classes.headerSection}>
                        <div className={classes.headerLeft}>
                            <IconButton 
                                onClick={() => props.history.goBack()} 
                                size="small"
                                style={{ padding: '4px', color: '#000' }}
                            >
                                <ArrowBackIcon fontSize="small" />
                            </IconButton>
                            <Typography className={classes.headerSubtitle}>
                                {selectedCity ? selectedCity.toLowerCase() : 'All Cities'} | {events.length} {events.length === 1 ? 'Event' : 'Events'}
                            </Typography>
                        </div>
                        <div className={classes.headerRight}>
                            <IconButton size="small" style={{ padding: '4px' }}>
                                <SearchIcon fontSize="small" />
                            </IconButton>
                        </div>
                    </div>

                    {/* Search Field */}
                    <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Search events..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className={classes.searchField}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />

                    {/* Filter Section */}
                    <div className={classes.filterSection}>
                        <Button
                            className={`${classes.filterButton} ${selectedCategory ? classes.activeFilter : ''}`}
                            startIcon={<FilterListIcon style={{ fontSize: '18px' }} />}
                            onClick={(e) => setCategoryMenuAnchor(e.currentTarget)}
                            style={{ 
                                backgroundColor: selectedCategory ? 'rgb(112, 57, 177)' : '#fff',
                                color: selectedCategory ? '#fff' : 'rgb(112, 57, 177)'
                            }}
                        >
                            All Categories {selectedCategory && `(${selectedCategory})`}
                        </Button>
                        <Button
                            className={`${classes.filterButton} ${selectedCity ? classes.activeFilter : ''}`}
                            startIcon={<LocationOnIcon style={{ fontSize: '18px' }} />}
                            onClick={(e) => setCityMenuAnchor(e.currentTarget)}
                            style={{ 
                                backgroundColor: selectedCity ? 'rgb(112, 57, 177)' : '#fff',
                                color: selectedCity ? '#fff' : 'rgb(112, 57, 177)'
                            }}
                        >
                            By Cities {selectedCity && `(${selectedCity})`}
                        </Button>
                        <Button
                            className={`${classes.filterButton} ${selectedVenue ? classes.activeFilter : ''}`}
                            startIcon={<LocationOnIcon style={{ fontSize: '18px' }} />}
                            onClick={(e) => setVenueMenuAnchor(e.currentTarget)}
                            style={{ 
                                backgroundColor: selectedVenue ? 'rgb(112, 57, 177)' : '#fff',
                                color: selectedVenue ? '#fff' : 'rgb(112, 57, 177)'
                            }}
                        >
                            Browse By Venues {selectedVenue && `(${selectedVenue})`}
                        </Button>
                        {hasActiveFilters && (
                            <Button
                                className={classes.filterButton}
                                onClick={clearFilters}
                                style={{ 
                                    marginLeft: 'auto',
                                    backgroundColor: '#fff',
                                    color: 'rgb(112, 57, 177)'
                                }}
                            >
                                Clear Filters
                            </Button>
                        )}
                    </div>

                    {/* Category Filter Menu */}
                    <Menu
                        anchorEl={categoryMenuAnchor}
                        open={Boolean(categoryMenuAnchor)}
                        onClose={() => setCategoryMenuAnchor(null)}
                        classes={{ paper: classes.menuPaper }}
                    >
                        <MenuItem onClick={() => handleCategoryFilter('')}>
                            All Categories
                        </MenuItem>
                        {uniqueCategories.map((category) => (
                            <MenuItem
                                key={category}
                                onClick={() => handleCategoryFilter(category)}
                                selected={selectedCategory === category}
                            >
                                {category}
                            </MenuItem>
                        ))}
                    </Menu>

                    {/* City Filter Menu */}
                    <Menu
                        anchorEl={cityMenuAnchor}
                        open={Boolean(cityMenuAnchor)}
                        onClose={() => setCityMenuAnchor(null)}
                        classes={{ paper: classes.menuPaper }}
                    >
                        <MenuItem onClick={() => handleCityFilter('')}>
                            All Cities
                        </MenuItem>
                        {uniqueCities.map((city) => (
                            <MenuItem
                                key={city}
                                onClick={() => handleCityFilter(city)}
                                selected={selectedCity === city}
                            >
                                {city}
                            </MenuItem>
                        ))}
                    </Menu>

                    {/* Venue Filter Menu */}
                    <Menu
                        anchorEl={venueMenuAnchor}
                        open={Boolean(venueMenuAnchor)}
                        onClose={() => setVenueMenuAnchor(null)}
                        classes={{ paper: classes.menuPaper }}
                    >
                        <MenuItem onClick={() => handleVenueFilter('')}>
                            All Venues
                        </MenuItem>
                        {uniqueVenues.map((venue) => (
                            <MenuItem
                                key={venue}
                                onClick={() => handleVenueFilter(venue)}
                                selected={selectedVenue === venue}
                            >
                                {venue}
                            </MenuItem>
                        ))}
                    </Menu>

                    {loading ? (
                        <Typography className={classes.noEvents}>Loading events...</Typography>
                    ) : events.length === 0 ? (
                        <Typography className={classes.noEvents}>
                            {hasActiveFilters ? 'No events match your filters.' : 'No events available at the moment.'}
                        </Typography>
                    ) : (
                        <>
                            <Grid container spacing={3}>
                                {events.map((event) => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={event._id}>
                                        <Card className={classes.eventCard} onClick={() => handleCardClick(event)}>
                                            <div className={classes.imageContainer}>
                                                {event.eventImage ? (
                                                    <img
                                                        className={classes.cardMedia}
                                                        src={event.eventImage}
                                                        alt={event.eventName}
                                                        onError={(e) => {
                                                            e.target.src = 'https://via.placeholder.com/400x280?text=No+Image';
                                                        }}
                                                    />
                                                ) : (
                                                    <img
                                                        className={classes.cardMedia}
                                                        src="https://via.placeholder.com/400x280?text=No+Image"
                                                        alt={event.eventName}
                                                    />
                                                )}
                                                <div className={classes.dateBar}>
                                                    {formatDateForBar(event.fromDate, event.toDate)}
                                                    {event.toDate && event.fromDate !== event.toDate && ' onwards'}
                                                </div>
                                            </div>
                                            <CardContent className={classes.cardContent}>
                                                <Typography className={classes.eventTitle}>
                                                    {event.eventName}
                                                </Typography>
                                                <Typography className={classes.eventLocation}>
                                                    {event.venue}
                                                    {(() => {
                                                        const cityName = typeof event.cityId === 'object' && event.cityId?.city 
                                                            ? event.cityId.city 
                                                            : event.city || '';
                                                        return cityName ? `, ${cityName}` : '';
                                                    })()}
                                                </Typography>
                                                <Chip
                                                    label={(() => {
                                                        const categoryName = typeof event.categoryId === 'object' && event.categoryId?.category 
                                                            ? event.categoryId.category 
                                                            : event.category || '';
                                                        return categoryName || getEventType(event.eventName);
                                                    })()}
                                                    size="small"
                                                    className={classes.eventCategory}
                                                    style={{
                                                        backgroundColor: '#f0f0f0',
                                                        color: '#333',
                                                        fontWeight: '500',
                                                        border: 'none',
                                                    }}
                                                />
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </>
                    )}
                </div>
            </Box>
            <Footer />
        </>
    );
}

export default withRouter(Events);

